import { FilterRuleType } from '@cxstudio/report-filters/constants/filter-rule-type.value';
import { FilterTypes } from '@cxstudio/report-filters/constants/filter-types-constant';

export class FilterEmptyObject {
	static FILTER = {type: FilterTypes.EMPTY};
	static RULE = {type: FilterRuleType.empty};
}

